import moment from 'moment';

export default class DataHelpers {

    static sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    static mergeIn(dest, source, fieldNames, emptyOnly) {
        dest = { ...dest };
        if (!fieldNames) {
            fieldNames = [];
            for (var prop in source) {
                if (source.hasOwnProperty(prop)) {
                    fieldNames.push(prop);
                }
            }
        }
        for (var i = 0; i < fieldNames.length; i++) {
            const fieldName = fieldNames[i];
            if ((!dest[fieldName] && source[fieldName]) || !emptyOnly) {
                dest[fieldName] = source[fieldName];
            }
        }
        return dest;
    }

    static groupBy(list, fnGetKey) {
        const results = {};
        list.forEach(item => {
            const key = fnGetKey(item);
            if (!results[key]) {
                results[key] = [];
            }
            results[key].push(item);
        });
        return results;
    }

    static isFunction(functionToCheck) {
        return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
    }

    static arrayToObject(array, field) {
        if (typeof(field) == 'undefined') {
            field = 'id';
        }
        const obj = {};
        array.forEach(item => {
            obj[item[field]] = item;
        });
        return obj;
    }

    static stripTimeZoneInformation(obj, fields) {
        obj = { ...obj };
        fields.forEach(field => {
            if (obj[field]) {
                const date = moment(obj[field]);
                obj[field] = date.format('YYYY-MM-DD');
            }
        });
        return obj;
    }

    static convertIDList(ids) {
        if (ids) {
            const list = [];
            for (let i in ids) {
                if (ids[i]) {
                    list.push(i);
                }
            }
            return list;
        }
        return null;
    }

    static areIDListsDifferent(oldVal, newVal) {
        const oldIDsList = oldVal.map(v => v.id);
        const newIDsList = newVal.map(v => v.id);
        if (oldIDsList.length != newIDsList.length) {
            return true;
        }
        const oldIDs = DataHelpers.arrayToObject(oldVal);
        const newIDs = DataHelpers.arrayToObject(newVal);
        for (let i = 0; i < oldIDsList.length; i++) {
            if (!newIDs[oldIDsList[i]]) {
                return true;
            }
        }
        for (let i = 0; i < newIDsList.length; i++) {
            if (!oldIDs[newIDsList[i]]) {
                return true;
            }
        }
    }
}